const getOrganizationOption = (organization) => ({
  label: organization.name + ' (' + ((organization && organization.companies) || []).length + ')',
  value: organization.id,
})

const getCompanyOption = (company) => ({
  label: company.name + ' (' + ((company && company.shops) || []).length + ')',
  value: company.id,
})

const companyHasAssignedShop = (company, assignedCompanyId, assignedShopId) => {
  const shops = company.shops || []
  return (
    company.id === assignedCompanyId ||
    shops.some((shop) => shop.companyId === assignedCompanyId || shop.id === assignedShopId)
  )
}

export const getInitialOrganizationSelection = (organizationViewsList = [], session = {}) => {
  const { assignedShop = {} } = session || {}
  const assignedCompanyId = assignedShop && assignedShop.companyId
  const assignedShopId = assignedShop && assignedShop.id

  const selectedOrgView =
    organizationViewsList.find((organization) => {
      const companies = organization.companies || []
      return companies.some((company) =>
        companyHasAssignedShop(company, assignedCompanyId, assignedShopId),
      )
    }) ||
    organizationViewsList[0] ||
    {}

  const companiesOptionsTemp = selectedOrgView.companies
    ? selectedOrgView.companies.map(getCompanyOption)
    : []

  const selectedCompanyView =
    selectedOrgView.companies &&
    (selectedOrgView.companies.find((company) =>
      companyHasAssignedShop(company, assignedCompanyId, assignedShopId),
    ) ||
      selectedOrgView.companies[0])

  return {
    selectedOrganization: selectedOrgView.id ? getOrganizationOption(selectedOrgView) : '',
    selectedCompany: selectedCompanyView ? getCompanyOption(selectedCompanyView) : '',
    companiesOptionsTemp,
    selectedOrgView,
    selectedCompanyView: selectedCompanyView || {},
  }
}

export const getFirstCompanyShop = (company = {}) => {
  const shops = company.shops || []
  return shops[0] || null
}

export const getOrganizationSelectOption = getOrganizationOption
export const getCompanySelectOption = getCompanyOption



// WEBPACK FOOTER //
// ./src/utils/switchAppSelection.js